/**
 * Lazy store reference to avoid circular imports.
 * The store is set once during app initialization (index.tsx).
 * Non-React code that needs store access (e.g. AuthUtils, tokenService)
 * uses getStoreRef() instead of importing the store directly.
 */

let storeRef: any = null;

export function setStoreRef(store: any) {
  storeRef = store;
}

export function getStoreRef(): any {
  return storeRef;
}
